module.exports = __webpack_public_path__ + "static/media/notifications_active.531f9e21.svg";